
<template>
  <div class="weekday-selector">
    <b-button-group>
      <b-button
        v-for="day in days"
        :key="day.value"
        pill
        class="day-btn"
        :class="{ active: selectedDays.includes(day.value) }"
        @click="toggleDay(day.value)">
        {{ day.label }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
import { BButtonGroup, BButton } from 'bootstrap-vue';

export default {
  name: 'CallWeekdaySelector',

  components: { BButtonGroup, BButton },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      days: [
        { label: 'Mo', value: 'Mon' },
        { label: 'Tu', value: 'Tue' },
        { label: 'We', value: 'Wed' },
        { label: 'Th', value: 'Thu' },
        { label: 'Fr', value: 'Fri' },
        { label: 'Sa', value: 'Sat' },
        { label: 'Su', value: 'Sun' }
      ]
    };
  },

  computed: {
    selectedDays () {
      return this.value;
    }
  },

  methods: {
    toggleDay (day) {
      const updated = [...this.selectedDays];

      const index = updated.indexOf(day);

      if (index > -1) {
        updated.splice(index, 1);
      } else {
        updated.push(day);
      }

      this.$emit('input', updated);
    }
  }
};
</script>

<style lang="scss" scoped>
.weekday-selector {
  margin-bottom: 16px;
  .btn-group {
    gap: 11px;
  }

  .btn-secondary:not(:disabled):not(.disabled).active:focus {
    box-shadow: none;
  }
  .btn-secondary:focus, .btn-secondary.focus {
     box-shadow: none;
  }

  .day-btn {
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    border: none;
    background: #ececec;
    color: #555;
    font-size: 16px;
    transition: all .2s ease;
    padding: 0 !important;
  }

  .day-btn.active {
    background: #25a244 !important;
    color: white !important;
  }

  .day-btn:hover {
    opacity: 0.9;
  }
}

</style>
